import { clone } from "./util";

// @flow
/**
 * UrlUtil工具类封装
 */
class UrlUtil {}

/**
 * 判断目标值是否存在，undefined、null、以及仅包含空白字符（空格、制表符、换行符等）都视为空值
 * @param {Object} value 要判断的目标值
 * @returns {Boolean} 目标值是否存在
 */
UrlUtil.defined = function name(value) {
    return value !== undefined && value !== null && !/^\s*$/.test(value);
};

/**
 * 根据url获取baseUrl和其他参数的数组
 * @param {String} url
 * @returns {Object}
 */
UrlUtil.getBaseUrlAndParams = function getBaseUrlAndParams(url) {
    // 获取传入的服务地址
    let baseUrl;
    // 获取服务详细信息
    let params = {};
    // 通过'?'分割数组
    let strParts = url.split("?");
    // 判断url合理性
    if (strParts.length === 0) {
        throw new Error("url传入不合法");
    } else if (strParts.length === 1) {
        // 获取baseUrl
        baseUrl = strParts[0];
    } else {
        // 获取baseUrl
        baseUrl = strParts[0];
        // 获取分割的key，value
        strParts[1].split("&").map(function (v) {
            let valueArr = [];
            // 判断存在filter=name='aaa'的情况并处理
            let regex = /(\w+)=(\w+='[^']+')/;
            if (v.match(regex)) {
                valueArr[0] = v.match(regex)[1];
                valueArr[1] = v.match(regex)[2];
            } else {
                valueArr = v.split("=");
            }
            params[valueArr[0]] = valueArr[1];
        });
        // 判断url合理性
        if (strParts.length >= 3) {
            console.err("url有多个'?'连接符，不合法");
        }
    }
    params = UrlUtil.deleteNullValue(params);
    // 返回baseUrl和其他参数的数组
    return {
        baseUrl,
        params,
    };
};

/**
 * 删除目标对象中的空值，之后返回新的对象
 * @param {Object} targetObject 要处理的对象
 * @returns {Object} 处理后的对象
 */
UrlUtil.deleteNullValue = function name(targetObject) {
    let objectClone = targetObject;
    if (targetObject instanceof Object) {
        objectClone = {};
        Object.keys(targetObject).forEach((key) => {
            if (UrlUtil.defined(key) && UrlUtil.defined(targetObject[key])) {
                objectClone[key] = targetObject[key];
            }
        });
    }
    return objectClone;
};

/**
 * 将Object对象转为字符串并返回，将忽略key或value为空的扩展参数
 * @param {Object} [targetObject={}] 目標對象，将对的属性名和属性值取出来拼装成字符串，
 * 格式如下：{key1:value1,key2,value2,...}
 * @return {String} 请求参数字符串，格式为: key1=value1&key2=value2...，开头和末尾没有&符号
 * */
UrlUtil.getObjectString = function (targetObject) {
    let objectString = "";
    if (targetObject instanceof Object) {
        targetObject = targetObject || {};
        const objectClone = UrlUtil.deleteNullValue(targetObject);
        Object.keys(objectClone).forEach(function (key) {
            objectString += `${key}=`;
            if (targetObject[key] instanceof Function) {
                objectString += targetObject[key]();
            } else if (targetObject[key] instanceof Object) {
                objectString += JSON.stringify(targetObject[key]);
            } else {
                objectString += targetObject[key];
            }
            objectString += "&";
        });
    }
    if (objectString.length > 0) {
        objectString = objectString.substring(0, objectString.length - 1);
    }
    return objectString;
};

/**
 * 删除初始化参数对象中的空值，之后返回新的对象
 * @param {Object} options 初始化参数对象
 * @returns {Object} 处理后的初始化参数对象
 */
UrlUtil.deleteNullValueInOptions = function (options) {
    options = options || {};
    // 删除空值属性
    return UrlUtil.deleteNullValue(clone(options));
};

export default UrlUtil;
